export default {
  init() {
    // Initialise Gallery Slick Slider Start
    jQuery('.slider-gallery').slick({
      slidesToShow: 1,
      centerMode: true,
      autoplay: true,
      autoplaySpeed: 4000,
      slidesToScroll: 1,
      swipeToSlide: true,
      dots: false,
      focusOnSelect: false,
      pauseOnFocus: false,
      infinite: true,
      prevArrow: '<button type="button" class="slick-prev"><span class="sr-only">Previous</span></button>',
      nextArrow: '<button type="button" class="slick-next"><span class="sr-only">Next</span></button>',
    });
    // Initialise Gallery Slick Slider End
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-about-us.js